import React, { useState } from "react";
import buildingImg from "../../assets/images/building_burz.png";
import axios from "axios";
// import { useNavigate } from "react-router-dom";
import { baseUrl } from "../../config/baseUrl";
import { toast, Bounce } from "react-toastify";
// import { DaySelector } from "../edu-helper/day-selector";

export default function CampusAdd({ setForceUpdate, forceUpdate }) {
  const [campusDescription, setCampusDescription] = useState();
  const [campusName, setCampusName] = useState();

  const handleSubmit = async (e) => {
    e.preventDefault();
    const data = {
      campus_description: campusDescription,
      campus_name: campusName,
    };
    let response;
    try {
      response = await axios(`${baseUrl}/create_campus/`, {
        method: "POST",
        headers: {
          Authorization: "Token " + localStorage.getItem("token"),
        },
        data: { ...data },
      });
      if (response?.status === 201) {
        let unique = document.getElementById("close4");
        unique.click();
        setForceUpdate(!forceUpdate);
        toast.success("Campus added Successfully!!", {
          position: "top-right",
          autoClose: 2000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
          theme: "light",
          transition: Bounce,
        });
      }
    } catch (error) {
      toast.error(error.response.data.message, {
        position: "top-right",
        autoClose: 2000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
        theme: "light",
        transition: Bounce,
      });
    }
  };

  return (
    <>
      <div
        className="modal fade custom-modal addcampus-modal"
        id="addcampus"
        tabIndex={-1}
        aria-labelledby="exampleModalLabel"
        aria-hidden="true"
      >
        <div className="modal-dialog modal-fullscreen">
          <div className="modal-content">
            <div className="modal-header justify-content-center">
              <h5 className="modal-title" id="">
                Add College
              </h5>
              <button
                type="button"
                className="modal-close"
                data-bs-dismiss="modal"
                aria-label="Close"
                id="close4"
              >
                <i className="fa fa-times" />
              </button>
            </div>
            <div className="modal-body">
              <div className="d-flex flex-row justify-content-center align-items-center">
                <div className="col-lg-5 text-center">
                  <div className="addbus-modal-innr">
                    <img src={buildingImg} alt="" width="316" height="316" />
                    <form action="" onSubmit={handleSubmit}>
                      <div className="row justify-content-center">
                        <div className="frm-bx mb-4 col-lg-8 mb-3 text-start">
                          <input
                            type="text"
                            className="form-control"
                            placeholder="Enter College Name"
                            name="campus_name"
                            onChange={(e) => {
                              setCampusName(e.target.value);
                            }}
                            value={campusName}
                          />
                          <span className="fa fa-solid fa-tent icon" />
                        </div>
                        <div className="frm-bx mb-4 col-lg-8 mb-3 text-start">
                          <input
                            type="text"
                            className="form-control"
                            placeholder="Enter College Address"
                            name="campus_desc"
                            onChange={(e) => {
                              setCampusDescription(e.target.value);
                            }}
                            value={campusDescription}
                          />
                          <span className="fa fa-solid fa-tent-arrows-downicon" />
                        </div>
                        <div className="frm-bx mb-4 col-lg-8 mb-3">
                          <button className="thm-btn" type="submit">
                            Submit
                          </button>
                        </div>
                        {/* <div>
                          <DaySelector
                            initialSelectedDays={daysModal}
                            onDaysChange={setDaysModal}
                          />
                        </div> */}
                      </div>
                    </form>
                  </div>
                </div>
              </div>
              {/* <div className="row justify-content-center align-items-center">
                <div className="col-lg-5 text-center">
                  <div className="addbus-modal-innr">
                    <img src={buildingImg} alt="" />
                    <form action="" onSubmit={handleSubmit}>
                      <div className="row justify-content-center">
                        <div className="frm-bx mb-4 col-lg-8 mb-3 text-start">
                          <select
                            name="company"
                            onChange={ChangeHandler}
                            className="form-select"
                            defaultValue={editVal?.company_name}
                          >
                            {companyNameData.map((arr) => {
                              return (
                                <option key={arr?.id} value={arr?.id}>
                                 {editVal?.company_name}
                                </option>
                              );
                            })}
                          </select>
                          <span className="fa fa-building icon" />
                        </div>
                        <div className="frm-bx mb-4 col-lg-8 mb-3 text-start">
                          <input
                            type="text"
                            className="form-control"
                            placeholder="Enter Bus Number"
                            name="bus_number"
                            onChange={ChangeHandler}
                            value={editVal?.bus_number}
                          />
                          <span className="fa fa-server icon" />
                        </div>
                        <div className="frm-bx mb-4 col-lg-8 mb-3 text-start">
                          <select
                            name="depo"
                            onChange={ChangeHandler}
                            className="form-select"
                            // value={editVal?.depo_name}
                          >
                            <option >Select Depot Name</option>
                            {depoData.map((arr) => {
                              return (
                                <option key={arr?.id} value={arr?.id}  selected={editVal?.depo_name === arr.depo_name && true}>
                                  {arr.depo_name}
                                </option>
                                
                              );
                            })}
                               
                          </select>
                          <span className="fa fa-server icon" />
                        </div>
                       
                        <div className="frm-bx mb-4 col-lg-8 mb-3">
                          <button className="thm-btn" type="submit">
                          Submit
                          </button>
                        </div>
                      </div>
                    </form>
                  </div>
                </div>
              </div> */}
            </div>
          </div>
        </div>
      </div>
    </>
  );
}
